import axios from '@/axios';
import router from '@/router';
import {dev} from '@/api/url';

// サーバーURL
const baseUrl = dev; // エンドポイント
const headers = {}
headers['Content-type'] = 'application/json'

const config = { //axiosの基本設定を定義
  timeout: 30000,//要請がtimeoutまでの時間,30秒
  method: null, //要請方法を指定
  emulateJSON: true,//JSONではなくURLの形式で送信する
  url: '',//要請されるURLを設定
  headers, //要請に使うヘーダ設定(以前設定したheaders)
  data: null, //データの初期値をnullで設定
  // withCredentials: true,
};


export default {
  deleteTaskList: (screenId, password, authUserId, sessionKey, staffName) => {
    config.url = baseUrl + "/api/screen/delete";
    config.method = "post"
    config.data = {
      screenId,
      password,
      authInfo: {
        authUserId,
        sessionKey,
      },
      staffName
    }

    return axios.request(config)
      .then(res => { return res })
      .catch(err => {
        let ErrMsg = '';
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message; // ネットワークエラー発生時
        } else if (err.response) {
          if (err.response.status === 401) {
            ErrMsg = err.response.data.msg; // 認証エラー発生時
            router.push('/login'); // ログインページにリダイレクト
          } else {
            ErrMsg = err.response.data.msg; // その他のエラーメッセージ
          }
        } else {
          ErrMsg = err.message; // その他のエラーメッセージ
        }
        return ErrMsg; // エラーメッセージを返す
      })
  },
}
